// store/cacheSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  data: {},
  timestamps: {},
  loading: false,
  error: null
};

const cacheSlice = createSlice({
  name: 'cache',
  initialState,
  reducers: {
    setCacheData: (state, action) => {
      const { key, data } = action.payload;
      state.data[key] = data;
      state.timestamps[key] = Date.now();
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearCache: (state, action) => {
      const key = action.payload;
      delete state.data[key];
      delete state.timestamps[key];
    }
  }
});

export const { setCacheData, setLoading, setError, clearCache } = cacheSlice.actions;
export default cacheSlice.reducer;